import { useTranslation } from 'react-i18next';
import {
  FontWeight,
  Heading,
  LiliButton,
  LiliButtonType,
  LiliLinkButton,
  LiliLinkSize,
  LiliLinkType,
  Text,
} from '@lili/lili-frontend-common';
import { ReactComponent as SmsIcon } from '@Assets/icons/sms-20.svg';

export interface DocVLinkPanelProps {
  onSendSmsClick: () => void;
  openResendOption: boolean;
  timeLeft: string | null;
  qrCode?: string;
  isLoading: boolean;
}

export const DocVLinkPanel = ({
  onSendSmsClick,
  openResendOption,
  timeLeft,
  qrCode,
  isLoading,
}: DocVLinkPanelProps) => {
  const { t } = useTranslation('nonUsSocure');

  const getSmsButtonTitle = () => {
    if (timeLeft) {
      return t('mainContent.sendAgainWithTimer', { timeLeft });
    }
    if (openResendOption) {
      return t('mainContent.sendAgain');
    }
    return t('mainContent.getLinkViaSms');
  };

  return (
    <div className='flex w-full flex-col items-center gap-[24px]'>
      <div className='hidden w-full flex-col items-center gap-[16px] rounded-[14px] border border-outline-primary-bw-05 bg-surface-primary-bw-00 px-[40px] py-[40px] doc:flex'>
        <div className='flex flex-col items-center gap-[11px]'>
          <Heading.H8 fontWeight={FontWeight.MEDIUM}>{t('mainContent.scanQrCode')}</Heading.H8>
          {qrCode ? (
            <img src={qrCode} alt='QR code' className='h-[151px] w-[151px]' />
          ) : (
            <div className='h-[151px] w-[151px] rounded-[8px] bg-surface-primary-bw-03' />
          )}
        </div>

        <div className='flex flex-col items-center gap-[16px]'>
          <div className='flex items-center gap-[12px]'>
            <span className='h-px w-[60px] bg-surface-primary-bw-05' />
            <Text.H10 fontWeight={FontWeight.MEDIUM}>{t('mainContent.orDivider')}</Text.H10>
            <span className='h-px w-[60px] bg-surface-primary-bw-05' />
          </div>

          <LiliButton
            id='docv-send-sms-button'
            type={LiliButtonType.SECONDARY}
            className='h-[40px] w-auto max-h-[40px] px-[16px] py-0 text-[14px]'
            icon={<SmsIcon className='h-[20px] w-[20px]' />}
            title={getSmsButtonTitle()}
            isLoading={isLoading}
            disabled={!!timeLeft}
            onClick={onSendSmsClick}
          />
        </div>
      </div>

      {!timeLeft && (
        <LiliLinkButton
          onClick={onSendSmsClick}
          id='get-new-link'
          type={LiliLinkType.QUIET}
          size={LiliLinkSize.SMALL}
          title={t('mainContent.needNewLink')}
          className='mx-auto hidden doc:flex'
        />
      )}
    </div>
  );
};
